import { TValidSdcColumns } from './../../sdc-columns.type';
// import { DEFAULT_SORT } from './../default-sort.constant';
import { sdcStateConfigConstant } from './../sdc-state-config.constant';
import {
  IColumnSort,
  IFilter,
  IGridViews,
  ISdcActivity,
  TValidSdcStates,
  TValidSdcViews,
} from './../sdc-state.typings';

export class PendingCourseGapPlanTableConfigService implements ISdcActivity {
  get humanName() {
    return sdcStateConfigConstant.PENDING_COURSE_GAP_PLAN_TABLE.humanName;
  }

  get state(): TValidSdcStates {
    return sdcStateConfigConstant.PENDING_COURSE_GAP_PLAN_TABLE.state;
  }

  get columns(): TValidSdcColumns[] {
    return ['studentName', 'studentId'];
  }

  get hiddenColumns(): TValidSdcColumns[] {
    return [];
  }

  get gridViews(): IGridViews {
    return {};
  }

  get filter(): IFilter {
    return {};
  }

  get sort(): IColumnSort[] {
    return [];
  }

  get bundleName() {
    return 'PENDING_COURSE_GAP_PLAN_TABLE';
  }

  get availableSdcViews(): TValidSdcViews[] {
    return sdcStateConfigConstant.PENDING_COURSE_GAP_PLAN_TABLE.availableSdcViews;
  }
}
